<template>
  <i-Switch
    v-model="item.value"
    @on-change="(flag) => item.onChange && item.onChange(item, formItems)"
  />
</template>
<script>
import props from './props'
export default {
  name: 'form-item-switch',
  mixins: [props],
  data () {
    return {}
  }
}
</script>